import { DropdownFilter } from "../../../../components/Filters/DropdownFilter";
import { AffiliationCountryChooser } from "../AffiliationCountriesChooser";
import { useSearchContext } from "../../contexts";
import { useTranslation } from "react-i18next";

interface AffiliationCountriesDropdownProps {
  onOpenChange?: (isOpen: boolean) => void;
}

export const AffiliationCountriesDropdown: React.FC<AffiliationCountriesDropdownProps> = ({ onOpenChange }) => {
  const { state } = useSearchContext();
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("State-affiliated")}
      counter={state.draftFilters.affiliations.value.length}
      isExclude ={state.draftFilters.affiliations.exclude}
      onOpenChange={onOpenChange}
    >
      <AffiliationCountryChooser />
    </DropdownFilter>
  )
};
